import { render } from "./Editbox.vue?vue&type=template&id=6fffdb59&scoped=true"
import script from "./Editbox.vue?vue&type=script&lang=js"
export * from "./Editbox.vue?vue&type=script&lang=js"

import "./Editbox.vue?vue&type=style&index=0&id=6fffdb59&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6fffdb59"

export default script